module.exports = __webpack_public_path__ + "img/jingying.2031ed90.jpg";